import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { onSessionExpired } from "../api/client";

const SessionExpiredModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const cleanup = onSessionExpired(() => {
      setIsVisible(true);
    });
    return cleanup;
  }, []);

  const handleRelogin = () => {
    signOut();
    setIsVisible(false);
    navigate("/login", { replace: true });
  };

  return (
    <AlertDialog open={isVisible}>
      <AlertDialogContent className="border-neutral-800 bg-neutral-900">
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-500/20 text-2xl">
              ⚠️
            </div>
            <div>
              <AlertDialogTitle className="text-neutral-100">Sesión expirada</AlertDialogTitle>
              <AlertDialogDescription className="text-neutral-400">
                Tu sesión ha caducado
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        <p className="text-sm text-neutral-300">
          Por seguridad, tu sesión ha expirado. Por favor, inicia sesión nuevamente para continuar.
        </p>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={handleRelogin}
            className="w-full bg-purple-600 text-white hover:bg-purple-700"
          >
            Iniciar sesión
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SessionExpiredModal;
